import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface StoreUnit {
  id: number;
  ucode: string;
  descr: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const useStoreUnits = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<StoreUnit> | StoreUnit[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<StoreUnit>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useStoreUnit = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<StoreUnit>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
